// extracted by mini-css-extract-plugin
export default {"container":"style_container__CYjlB","header":"style_header__axjnl","text":"style_text__sqD93"};